// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-deviations-checkpoints-table-wrapper {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checkpoints-table-wrapper/deviation-checkpoints-table-wrapper.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ","sourcesContent":[".fi-deviations-checkpoints-table-wrapper {\r\n    overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
